export function ZodErrors({ error, id }: { error: string[]; id: string }) {
  if (!error) return null
  return error.map((err: string, index: number) => (
    <div key={index} className="-mt-4 py-2 text-xs italic text-pink-500" id={id}>
      {err}
    </div>
  ))
}
